module.exports = __webpack_public_path__ + "1b13b41d2f2d1a31e1555a67b0f74033.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/eldar-vignette-preview-460.jpg
// module id = 274
// module chunks = 0